import { render } from "./user_menu.vue?vue&type=template&id=5fae77ba&scoped=true"
import script from "./user_menu.vue?vue&type=script&lang=js"
export * from "./user_menu.vue?vue&type=script&lang=js"

import "./user_menu.vue?vue&type=style&index=0&id=5fae77ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fae77ba"]])

export default __exports__